const $ = require('jQuery');

const ResourcesSearch = function (el) {
  this.$el = $(el);
  this.$featuresBody = this.$el.find('.js-features-body');
  this.$featuresHeroContent = this.$el.find('.js-features-hero-content');
  this.$featuresHeroTitle = this.$el.find('.js-features-hero-title');
  this.$featuresHeroFilter = this.$el.find('.js-features-hero-filter');
  this.$featuresFilterDropdown = this.$el.find('.js-features-filter-dropdown');
  this.$searchHeroContent = this.$el.find('.js-search-hero-content');
  this.$searchNoResults = this.$el.find('.js-search-no-results');
  this.$searchResults = this.$el.find('.js-search-results');
  this.$searchTerm = this.$el.find('.js-search-term');
  this.$searchbox = this.$el.find('.js-resources-searchbox');
  this.$searchboxContainer = this.$el.find('.js-searchbox-container');
  this.$termHeroContent = this.$el.find('.js-term-hero-content');
  this.$termPageTitle = this.$el.find('.js-term-page-title');
  this.$resourceFilter = this.$el.find('.js-resources-filter');
  this.$resourceFilterOption = this.$el.find('.js-resources-filter-option');
  this.$selectedResourceFilters = this.$el.find('.js-resources-selected-filters');
  this.$selectedPillRemoveBtn = this.$el.find('.js-resources-selected-pill-remove');

  this.initFilterEvents();
}

ResourcesSearch.prototype.initFilterEvents = function () {
  this.$resourceFilter.on('click', this.toggleFilterDropdown.bind(this));
  this.$resourceFilterOption.on('click', this.onResourceFilterOptionClick.bind(this));
  $(document).on('click', '.js-resources-selected-pill-remove', this.onSelectedPillRemoveBtnClick.bind(this));
}

ResourcesSearch.prototype.onSelectedPillRemoveBtnClick = function (e) {
  const $pill = $(e.target).closest('.itbl-c-hero__filter-pill');
  const filter = $pill.attr('data-value');

  this.removeFilterFromSelected(filter);

  const $option = this.$resourceFilterOption.filter(`[data-value="${filter}"]`);
  $option.removeClass('active');

  this.filterTheResources();
}

ResourcesSearch.prototype.onResourceFilterOptionClick = function (e) {
  const $option = $(e.target);
  const optionValue = $option.attr('data-value');
  const text = $option.text();

  // if option value is undefined or not set then wait for 500ms and try again
  if (typeof optionValue === 'undefined' || optionValue === '') {
    setTimeout(() => {
      this.onResourceFilterOptionClick(e);
    }, 500);
    return;
  }

  if ($option.hasClass('active')) {
    $option.removeClass('active');

    this.removeFilterFromSelected(optionValue);
  } else {
    $option.addClass('active');

    this.addFilterToSelected(optionValue, text);
  }

  this.filterTheResources();
}

ResourcesSearch.prototype.filterTheResources = function () {
  const selectedFilters = this.getSelectedFilters();

  if (selectedFilters.length === 0) {
    this.showAllResources();
  } else {
    this.hideAllResources();

    selectedFilters.forEach(filter => {
      switch (filter) {
        case 'popular-download':
        case 'webinar':
        case 'teardown':
        case 'case-study':
        case 'template':
        case 'video':
        case 'unboxing-guide':
          this.filterResourcesByTerm(filter);
          break;
        case 'recent':
        case 'recent_blog':
        case 'whitepaper':
          this.filterResourcesByType(filter);
          break;
        case 'all-post-types':
          this.showAllPostTypes();
          break;
        default:
          break;
      }
    });
  }
}

ResourcesSearch.prototype.showAllResources = function () {
  const $resources = $('.itbl-c-cards.hide');

  $resources.each(function () {
    const $resource = $(this);
    $resource.removeClass('hide');
  });
}

ResourcesSearch.prototype.showAllPostTypes = function () {
  const $resources = $('.itbl-c-cards.hide');
  const $skipResources = ['popular-download', 'recent'];

  $resources.each(function () {
    if( !$skipResources.includes($(this).attr('data-resource-term')) && !$skipResources.includes($(this).attr('data-content-type')) ) {
      const $resource = $(this);
      $resource.removeClass('hide');
    }
  });
}

ResourcesSearch.prototype.filterResourcesByType = function (type) {
  let $resources
  
  if(type === 'all-post-types') {
    $resources = $('.itbl-c-cards[data-its-post-type="true"]');
  } else {
    $resources = $('.itbl-c-cards[data-content-type="' + type + '"]');
  }

  $resources.each(function () {
    const $resource = $(this);
    $resource.removeClass('hide');
  });
}

ResourcesSearch.prototype.filterResourcesByTerm = function (term) {
  const $resources = $('.itbl-c-cards[data-resource-term="' + term + '"]');

  $resources.each(function () {
    const $resource = $(this);
    $resource.removeClass('hide');
  });
}

ResourcesSearch.prototype.hideAllResources = function () {
  const $resources = $('.itbl-c-cards');

  $resources.each(function () {
    const $resource = $(this);
    $resource.addClass('hide');
  });
}

ResourcesSearch.prototype.getSelectedFilters = function () {
  const $selectedPills = this.$selectedResourceFilters.find('.itbl-c-hero__filter-pill');
  const filters = $selectedPills.map(function () {
    return $(this).attr('data-value');
  }).get();

  return filters;
}

ResourcesSearch.prototype.addFilterToSelected = function (filter, text) {
  const markup = `
    <div class="itbl-c-hero__filter-pill" data-value="${filter}">
      ${text}
      <div class="itbl-c-hero__filter-pill-remove js-resources-selected-pill-remove"></div>
    </div>
  `;

  this.$selectedResourceFilters.append(markup);
}

ResourcesSearch.prototype.removeFilterFromSelected = function (filter) {
  const $pill = this.$selectedResourceFilters.find(`[data-value="${filter}"]`);
  $pill.remove();
}

ResourcesSearch.prototype.toggleFilterDropdown = function () {
  this.$resourceFilter.toggleClass('active');
}

ResourcesSearch.prototype.showSearchbox = function () {
  this.$searchboxContainer.removeClass('hide');
}

ResourcesSearch.prototype.showFilterDropdown = function () {
  this.$featuresFilterDropdown.removeClass('hide');
}

ResourcesSearch.prototype.showInitialPage = function () {
  const search = this.getSearchQueryString();
  const term = this.getTermQueryString();

  if (search) {
    this.prefillSearchField(search);

    const event = {
      target: {
        value: search
      }
    };

    this.onSearchboxChange(event);
  } else if (term) {
    const termPageTitle = this.getTQueryString();
    this.showTermPage(termPageTitle, term);
  } else {
    this.showFeatures();
  }
}

ResourcesSearch.prototype.deleteTermQueryString = function () {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  searchParams.delete('term');
  searchParams.delete('t');

  const state = url.pathname + url.search + url.hash;

  window.history.replaceState(null, window.document.title, state);
}

ResourcesSearch.prototype.closeTermPage = function () {
  this.showFeatures();
  this.deleteTermQueryString();
}

ResourcesSearch.prototype.onpopstate = function () {
  this.closeTermPage();
}

ResourcesSearch.prototype.scrollToTopOfPage = function () {
  const $body = $("html, body");
  $body.stop().animate({scrollTop:0}, 500, 'swing', () => {});
}

ResourcesSearch.prototype.showFeatures = function () {
  this.hideAllContent();
  this.$featuresBody.removeClass('hide');
  this.$featuresHeroContent.removeClass('hide');
  this.$featuresFilterDropdown.removeClass('hide');
  this.$selectedResourceFilters.removeClass('hide');
  this.$featuresHeroTitle.removeClass('hide');
  this.$featuresHeroFilter.removeClass('hide');
  this.positionSearchboxOnTheSide();
}

ResourcesSearch.prototype.makeSearchboxFullWidth = function () {
  this.$searchboxContainer.addClass('medium-7');
  ['medium-5', 'medium-offset-2', 'large-offset-2'].forEach(className => {
    this.$searchboxContainer.removeClass(className);
  });
}

ResourcesSearch.prototype.positionSearchboxOnTheSide = function () {
  this.$searchboxContainer.removeClass('medium-7');
  ['medium-5', 'medium-offset-2', 'large-offset-2'].forEach(className => {
    this.$searchboxContainer.addClass(className);
  });
}

ResourcesSearch.prototype.showSearchResults = function () {
  this.hideAllContent();
  this.$featuresHeroFilter.removeClass('hide');
  this.$featuresFilterDropdown.addClass('hide');
  this.$selectedResourceFilters.addClass('hide');
  this.$searchboxContainer.removeClass('hide');
  this.$searchHeroContent.removeClass('hide');
  this.$searchResults.removeClass('hide');
  this.makeSearchboxFullWidth();
}

ResourcesSearch.prototype.changeTermPageTitle = function (title) {
  this.$termPageTitle.text(title);
}

ResourcesSearch.prototype.showResourcesForTerm = function (term) {
  const $termPageResources = $('.js-search-result');

  $termPageResources.addClass('hide');

  const isRecentsPage = term === 'recent';

  if (isRecentsPage) {
    for (let i = 0; i < $termPageResources.length && i < 40; i++) {
      $($termPageResources[i]).removeClass('hide')
    }
    return;
  }

  $termPageResources.each(function () {
    const $resource = $(this);
    const terms = $resource.attr('data-terms');
    const termRegexp = new RegExp(term, 'i');

    const belongsOnThisTermPage = termRegexp.test(terms);

    if (belongsOnThisTermPage) {
      $resource.removeClass('hide');
    }
  });
}

ResourcesSearch.prototype.getValueFromQueryString = function (key) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const value = searchParams.get(key);
  return value;
}

ResourcesSearch.prototype.getSearchQueryString = function () {
  return this.getValueFromQueryString('search');
}

ResourcesSearch.prototype.getTermQueryString = function () {
  return this.getValueFromQueryString('term');
}

ResourcesSearch.prototype.getTQueryString = function () {
  return this.getValueFromQueryString('t');
}

ResourcesSearch.prototype.prefillSearchField = function (value) {
  this.$searchbox.val(value);
}

ResourcesSearch.prototype.showTermPage = function (title, term) {
  this.hideAllContent();
  this.makeSearchboxFullWidth();
  this.$featuresHeroContent.addClass('hide');
  this.$termHeroContent.removeClass('hide');
  this.$searchResults.removeClass('hide');
  this.changeTermPageTitle(title);
  this.showResourcesForTerm(term);
  this.setTermPageQueryString(term, title);
  this.scrollToTopOfPage();
}

ResourcesSearch.prototype.hideAllContent = function () {
  this.$featuresBody.addClass('hide');
  this.$featuresHeroTitle.addClass('hide');
  this.$featuresHeroFilter.addClass('hide');
  this.$featuresFilterDropdown.addClass('hide');
  this.$selectedResourceFilters.addClass('hide');
  this.$searchHeroContent.addClass('hide');
  this.$searchResults.addClass('hide');
  this.$termHeroContent.addClass('hide');
}

ResourcesSearch.prototype.filterResources = function (keyword, resources) {
  const keywordRegex = new RegExp(keyword, 'i');

  const filtered = resources.filter(post => {
    const title = post.post_title;
    const excerpt = post.post_excerpt;

    return keywordRegex.test(title) || keywordRegex.test(excerpt);
  });

  return filtered;
}

ResourcesSearch.prototype.overrideViewAllButtonAction = function () {
  const $viewAllLinks = this.$featuresBody.find('.itbl-b-layout__heading a');

  const boundOnClickViewAll = this.onClickViewAll.bind(this);

  $viewAllLinks.each(function () {
    const $link = $(this);
    const href = $link.attr('href');

    // Overrides only in page links
    const shouldOverride = /^\?/.test(href);

    if (shouldOverride) {
      $link.on('click', boundOnClickViewAll);
    }
  });
}

ResourcesSearch.prototype.onClickViewAll = function (e) {
  e.preventDefault();

  const $link = $(e.target);
  const href = $link.attr('href');
  const url = window.location.href;
  const urlWithoutQueryString = url.split('?')[0];
  const urlWithNewQueryString = urlWithoutQueryString + href;
  const targetUrl = new URL(urlWithNewQueryString);
  const queryParams = targetUrl.searchParams;
  const term = queryParams.get('term');
  const title = queryParams.get('t');

  this.showTermPage(title, term);
}

ResourcesSearch.prototype.showSearchResultsByPostId = function (postIds) {
  $('.js-search-result').addClass('hide');

  postIds.forEach(postId => {
    const idSelector = '#resources-search-result-' + postId;
    const $result = $(idSelector);
    $result.removeClass('hide');
  });
}

ResourcesSearch.prototype.updateSearchHeaderTerm = function (keyword) {
  const searchTerm = keyword
    ? ('"' + keyword + '"')
    : '...';

  this.$searchTerm.text(searchTerm);
}

ResourcesSearch.prototype.setSearchQueryString = function (keyword) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  if (keyword === '') {
    searchParams.delete('search');
  } else {
    searchParams.set('search', keyword);
  }

  const state = url.pathname + url.search + url.hash;

  window.history.replaceState(null, window.document.title, state);
}

ResourcesSearch.prototype.setTermPageQueryString = function (term, title) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  if (term === '') {
    searchParams.delete('term');
    searchParams.delete('t');
  } else {
    searchParams.set('term', term);
    searchParams.set('t', title);
  }

  const state = url.pathname + url.search + url.hash;

  window.history.pushState(null, window.document.title, state);
}

ResourcesSearch.prototype.isOnTermPage = function () {
  const term = this.getTermQueryString();
  return !!term;
}

ResourcesSearch.prototype.clearSearchbox = function () {
  this.$searchbox.val('');
}

ResourcesSearch.prototype.closeSearchPage = function () {
  const isOnTermPage = this.isOnTermPage()

  if (isOnTermPage) {
    const term = this.getTermQueryString();
    const title = this.getTQueryString();
    this.showTermPage(title, term);
  } else {
    this.showFeatures();
  }

  this.clearSearchbox();
}

ResourcesSearch.prototype.onSearchboxChange = function (e) {
  const keyword = e.target.value;
  const resources = window.resources;

  const filteredPosts = this.filterResources(keyword, resources);
  const resultCount = filteredPosts.length;
  const filteredPostIds = filteredPosts.map(post => post.ID);

  this.showSearchResultsByPostId(filteredPostIds);

  if (keyword === '') {
    this.closeSearchPage();
  } else {
    this.showSearchResults();
  }

  this.updateSearchHeaderTerm(keyword);

  this.setSearchQueryString(keyword);

  if (resultCount === 0) {
    this.$searchNoResults.removeClass('hide');
  } else {
    this.$searchNoResults.addClass('hide');
  }
}

$(document).ready(function () {
  $('.js-resources-page').each(function () {
    new ResourcesSearch(this);
  });
});
